import React, { useContext } from "react";
import styled from "styled-components";
import BreakpointContext from "../../contexts/breakpointContext";
import useCurrentUser from "../../hooks/useCurrentUser";
import ThemeToggle from "./ThemeToggle";

const StyledFooter = styled.footer`
  width: 100%;
  overflow: auto;
  background: ${(props) =>
    props.theme.colors.shiftToneOpposite(props.theme.colors.main, 0.15)};
  box-shadow: 0 0 20px ${(props) => props.theme.colors.boxShadow};
`;

const StyledFooterContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const Footer = ({ changeTheme, themeName }) => {
  const currentUser = useCurrentUser();
  const breakpoints = useContext(BreakpointContext);

  return (
    <StyledFooter>
      <StyledFooterContentDiv className={"footer-content"}>
        {currentUser.isAdmin() && (
          <>
            <p>{breakpoints.message()}</p>
            <ThemeToggle changeTheme={changeTheme} themeName={themeName} />
          </>
        )}
        <p style={{ textAlign: "center", opacity: 0.75 }}>
          East-West Football League - Fantasy Football Since 2000
          <br />
          ©2021 Matthew Gadbois
          <br />
          {process.env.NODE_ENV} mode - build 3
        </p>
      </StyledFooterContentDiv>
    </StyledFooter>
  );
};

export default Footer;
